import type { PlanStatus } from '@/types'
import { WAVE_CALENDARS, WAVE_FIXTURES } from './data'

export interface WavePlan {
  id: string
  name: string
  status: PlanStatus
  subclassId: string
  calendarId: string
  mfps: { id: string; name: string }[]
}

// One demo plan per calendar/subclass: each retains its existing scenario drafts.
export const WAVE_PLANS: WavePlan[] = WAVE_CALENDARS.flatMap(calendar =>
  WAVE_FIXTURES.map((fixture, index) => ({
    id: `${calendar.id}-${fixture.id}`,
    name: `${fixture.name} ${calendar.year}`,
    status:
      calendar.year === 2027
        ? 'Draft'
        : index === 0
          ? 'Approved'
          : 'In Progress',
    subclassId: fixture.id,
    calendarId: calendar.id,
    mfps:
      index === 1
        ? []
        : [
            {
              id: `halloween-${calendar.id}`,
              name: `Halloween ${calendar.year} MFP`,
            },
            ...(index === 2
              ? [
                  {
                    id: `home-${calendar.id}`,
                    name: `Home Decor ${calendar.year} MFP`,
                  },
                ]
              : []),
          ],
  }))
)

export function getWavePlan(planId: string | undefined) {
  return WAVE_PLANS.find(plan => plan.id === planId)
}

export function wavePlanPath(
  planId: string,
  view?: 'skus' | 'distribution-centers'
) {
  return `/wave-planning/plans/${planId}${view ? `/${view}` : ''}`
}

export function wavePlanMfpLabel(plan: WavePlan) {
  return plan.mfps.map(mfp => mfp.name).join(', ') || 'Not associated'
}

export function getRollupPlans(params: URLSearchParams) {
  const ids = new Set(
    params.getAll('planIds').flatMap(value => value.split(','))
  )
  return WAVE_PLANS.filter(plan => ids.has(plan.id))
}

export function waveRollupPath(ids: string[]) {
  const params = new URLSearchParams({ planIds: [...new Set(ids)].join(',') })
  return `/wave-planning/rollup?${params}`
}
